import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '../../../../core/animations';
import { Ticket } from '../../../../core/modelos/ticket';
import { TicketsService } from '../tickets.service';
import { NotificacionesService } from '../../../../core/notificaciones/notificaciones.service';

@Component({
    selector: 'fuse-tickets-detalle',
    templateUrl: './tickets-detalle.component.html',
    styleUrls: ['./tickets-detalle.component.scss'],
    animations   : fuseAnimations
})
export class TicketsDetalleComponent implements OnInit {

    ticket: Ticket;
    idTicket: number;

    formulario: FormGroup;

    constructor(
        private http: HttpClient,
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private ticketsService: TicketsService,
        private router: Router,
        private notificaciones: NotificacionesService
    ) {
        // Traigo el ticket por parametro
        this.activatedRoute.params.subscribe(params => {
            this.idTicket = params['idTicket'];
        });
    }

    ngOnInit() {

        this.ticketsService.getTicket(this.idTicket).subscribe(
            data => {
                if (data.success) {
                    this.ticket = data.items;
                    this.crearFormulario();

                } else {
                    // CONTROLAR ERROR
                    this.notificaciones.mostrarAviso(this.notificaciones.mensajes.IdiomaActual.Tickets.TicketNOObtenido);
                    this.router.navigate(['tickets']);
                }
            },
            err => {
                // CONTROLAR ERROR
                this.notificaciones.errorServidor(err.status);
                this.router.navigate(['tickets']);
            }
        );

    }

    crearFormulario() {

        this.formulario = this.fb.group({

            'titulo'    : new FormControl({value: this.ticket.titulo ? this.ticket.titulo : null, disabled: true}),
            'descripcion'    : new FormControl({value: this.ticket.descripcion ? this.ticket.descripcion : null, disabled: true}),
            'estado'    : new FormControl({value: this.ticket.estado ? this.ticket.estado : null, disabled: true}),
            'solicitante' : new FormControl({value: this.ticket.solicitante ? this.ticket.solicitante.nombre : null, disabled: true}),
            'asignado'    : new FormControl({value: this.ticket.asignado ? this.ticket.asignado.nombre : null, disabled: true}),
            'activo'    : new FormControl({value: this.ticket.activo ? this.ticket.activo.codigo : null, disabled: true}),
            'prioridad'   : new FormControl({value: this.ticket.prioridad ? this.ticket.prioridad : null, disabled: true}),
            // 'documento'  : new FormControl({value: this.ticket.documento, disabled: true}),
            'observaciones'    : new FormControl({value: this.ticket.observaciones ? this.ticket.observaciones : null, disabled: true}),
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/tickets/detalle/tickets-detalle.component.ts